import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { EChartsOption } from 'echarts';
import { NGX_ECHARTS_CONFIG, NgxEchartsModule } from 'ngx-echarts';
import { SpinnerComponent } from '../spinner/spinner.component';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'ui-card-chart',
  standalone: true,
  imports: [NgxEchartsModule, SpinnerComponent],
  template: `
    <div class="mb-3 card">
      <div class="card-body">
        <div class="row align-items-center card-title">
          <!-- HEADER TITLE -->
          <div class="col-auto d-none d-md-flex">
            <ng-content select="[card-title]"></ng-content>
          </div>
          <!-- BUTTONS -->
          <div class="col d-none d-md-block text-end">
            <ng-content select="[card-actions]"></ng-content>
          </div>
          <!-- ADD BTN SMALL DEVICE-->
          <div class="col d-block d-md-none text-end">
            <ng-content select="[card-sm-actions]"></ng-content>
          </div>
        </div>
        @if (loading) {
        <common-ui-spinner></common-ui-spinner>
        } @if (chartOptions === null) {
        <div class="row">
          <div class="col-12 text-center text-muted">
            <h6>Sin datos para mostrar</h6>
          </div>
        </div>
        } @else {

        <div
          class="graph-container"
          echarts
          [options]="chartOptions"
          [autoResize]="true"
        ></div>

        }
      </div>
    </div>
  `,
  styles: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {
      provide: NGX_ECHARTS_CONFIG,
      useFactory: () => ({ echarts: () => import('echarts') }),
    },
  ],
})
export class CardChartComponent {
  @Input() chartOptions: EChartsOption | null = null;
  @Input() loading = true;
}
